module.exports = __webpack_public_path__ + "files/f2d83436dcf3f53375518292e917643c.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/Source-Sans-Pro-regular.ttf
// module id = 635
// module chunks = 60